import { z } from "zod";
import { CommonModels } from "@/data/common/common.models";

export namespace ProfileDemoModels {
/** 
 * DemoProfileResponseDtoSchema 
 * @type { object }
 * @property { string } userId  
 */
export const DemoProfileResponseDtoSchema = z.object({ userId: z.string() });
export type DemoProfileResponseDto = z.infer<typeof DemoProfileResponseDtoSchema>;


/** 
 * ProfileDemoGetPastResponseSchema 
 * @type { object }
 * @property { object[] } order List of order definitions 
 * @property { number } page 1-indexed page number to begin from 
 * @property { string } cursor ID of item to start after 
 * @property { string } nextCursor Cursor for next set of items 
 * @property { number } limit Items per response 
 * @property { number } totalItems Total available items 
 * @property { CommonModels.LiveShowResponseDto[] } items  
 */
export const ProfileDemoGetPastResponseSchema = z.object({ ...CommonModels.PaginationDtoSchema.shape, ...z.object({ items: z.array(CommonModels.LiveShowResponseDtoSchema).nullable() }).partial().shape });
export type ProfileDemoGetPastResponse = z.infer<typeof ProfileDemoGetPastResponseSchema>;


/** 
 * ProfileDemoGetUpcomingResponseSchema 
 * @type { object }
 * @property { object[] } order List of order definitions 
 * @property { number } page 1-indexed page number to begin from 
 * @property { string } cursor ID of item to start after 
 * @property { string } nextCursor Cursor for next set of items 
 * @property { number } limit Items per response 
 * @property { number } totalItems Total available items 
 * @property { CommonModels.LiveShowResponseDto[] } items  
 */
export const ProfileDemoGetUpcomingResponseSchema = z.object({ ...CommonModels.PaginationDtoSchema.shape, ...z.object({ items: z.array(CommonModels.LiveShowResponseDtoSchema).nullable() }).partial().shape });
export type ProfileDemoGetUpcomingResponse = z.infer<typeof ProfileDemoGetUpcomingResponseSchema>;


/** 
 * ProfileDemoGetCurrentResponseSchema 
 * @type { array }
 */
export const ProfileDemoGetCurrentResponseSchema = z.array(CommonModels.LiveShowResponseDtoSchema);
export type ProfileDemoGetCurrentResponse = z.infer<typeof ProfileDemoGetCurrentResponseSchema>;


}
